import React from "react";
import { Flex, FormControl, FormLabel, Input, Select } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { GOLD_BORDER } from "constants/brandColors";

const fieldProps = {
  bg: "white",
  borderColor: GOLD_BORDER,
  focusBorderColor: GOLD_BORDER,
};

// Shared date-range + bucket-interval controls for the News/Broadcast
// reports. `from`/`to` are plain "YYYY-MM-DD" strings (or "" for "use the
// backend's default rolling 30-day window") since that's all the reports
// API's date parser needs. `interval` only affects the two trend endpoints
// but lives here since it's shown alongside the same date range.
export default function ReportFilters({ from, to, onFromChange, onToChange, interval, onIntervalChange }) {
  const { t } = useTranslation();

  return (
    <Flex gap={4} wrap="wrap" align="flex-end">
      <FormControl w="auto">
        <FormLabel fontSize="sm" mb={1}>{t("From")}</FormLabel>
        <Input
          type="date"
          value={from}
          onChange={(e) => onFromChange(e.target.value)}
          {...fieldProps}
        />
      </FormControl>
      <FormControl w="auto">
        <FormLabel fontSize="sm" mb={1}>{t("To")}</FormLabel>
        <Input
          type="date"
          value={to}
          onChange={(e) => onToChange(e.target.value)}
          {...fieldProps}
        />
      </FormControl>
      <FormControl w="auto" minW="140px">
        <FormLabel fontSize="sm" mb={1}>{t("Interval")}</FormLabel>
        <Select value={interval} onChange={(e) => onIntervalChange(e.target.value)} {...fieldProps}>
          <option value="day">{t("Day")}</option>
          <option value="week">{t("Week")}</option>
          <option value="month">{t("Month")}</option>
        </Select>
      </FormControl>
    </Flex>
  );
}
